import {Button, Card, CardActions, CardContent} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import * as React from "react";

interface StatsCardProps {
    title: string;
    subtitle: string;
    loading: boolean;
    children: React.ReactNode;
    linkTo?: string
}

export default (props: StatsCardProps) => {
    return (
        <Card>
            <CardContent sx={{pb: 0}}>
                <Typography gutterBottom variant="body1" component="div">
                    {props.title}
                    <Typography gutterBottom variant="caption" component="div">
                        {props.subtitle}
                    </Typography>
                </Typography>
                {props.children}
            </CardContent>
            <CardActions>
                {props.linkTo && (
                    <Link to={props.linkTo} style={{'textDecoration': 'none', 'color': 'inherit'}}>
                        <Button size="small" sx={{'fontWeight': 400}}>View Details</Button>
                    </Link>
                )}

            </CardActions>
        </Card>
    )
}